import React, { memo, useCallback, useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { addClass } from '../../../utils/utils';
import { setGameCategoryTag, getSearchTag, setSelectedTag } from '../../../actions/game';
import ListItem from './ListItem';
import { logging, logPostInfo } from '../../../actions/log';
import styles from './CategoryList.module.less';
import DefaultImg from '../../../static/game/game_default.png';
import { PCStoreJsBridge } from '../../../nativeapi';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const SelectGameCode = createSelector(
  state => state.game,
  game => game.gameSelectCode,
);

const SelectShowCategoryTag = createSelector(
  state => state.game,
  game => game.showCategoryList,
);

const SelectSearchTag = createSelector(
  state => state.game,
  game => game.gameSearchTag,
);

const SelectGameSelectTag = createSelector(
  state => state.game,
  game => game.categorySelectedTag,
);

const SelectGameSort = createSelector(
  state => state.game,
  game => game.gameSort,
);

export default memo(() => {
  const dispatch = useDispatch();
  const Node = useRef(null);
  const gameCode = useSelector(SelectGameCode);
  const categoryTag = useSelector(SelectShowCategoryTag);
  const searchTag = useSelector(SelectSearchTag);
  const [keyWords, setKeyWords] = useState(null);
  const [searchShow, setSearchShow] = useState(false);
  const gameSelectTag = useSelector(SelectGameSelectTag);
  const logInfoData = useSelector(selectLogInfo);
  const gameSort = useSelector(SelectGameSort);

  // 监听轮播频率列表是否显示
  useEffect(() => {
    if (searchShow) {
      window.addEventListener('click', handleSearchClose, false);
    }

    return () => {
      window.removeEventListener('click', handleSearchClose);
    };
  }, [searchShow]);

  const closeList = () => {
    addClass(Node.current, styles.list_out);
  };

  const handleSearch = useCallback(
    e => {
      let keyWord = e.target.value;
      setKeyWords(keyWord);
      dispatch(getSearchTag(keyWord));
      if (keyWord) {
        setSearchShow(true);
      } else {
        setSearchShow(false);
      }
    },
    [searchTag],
  );

  const clickTag = useCallback(
    info => {
      let params = {
        code: '1',
        info,
      };
      dispatch(setSelectedTag(params));
      setSearchShow(false);
      dispatch(
        logging({
          category: 'C',
          action: 'Game_Base_Search',
          label: '',
          param2: {
            source: 'Game_Base',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            tagid: info.tagId,
            search_word: keyWords,
          },
        }),
      );
    },
    [categoryTag, gameSelectTag, keyWords],
  );

  const handleSearchClose = e => {
    if (e.target.className !== 'search_have_result' || e.target.className !== 'search_no_result') {
      setSearchShow(false);
    }
  };

  // 移动窗口Mouse
  const handleWindowHtCaption = useCallback(ev => {
    ev.stopPropagation();
    if (ev.target instanceof HTMLAnchorElement || ev.target instanceof HTMLInputElement) {
      return;
    }
    PCStoreJsBridge.startMoveWindow();
  }, []);
  // 移动窗口触屏
  const handleTouchStart = useCallback(ev => {
    ev.stopPropagation();
    if (ev.target instanceof HTMLAnchorElement || ev.target instanceof HTMLInputElement) {
      return;
    }
    if (ev.targetTouches) {
      PCStoreJsBridge.touchStartWindow(ev.targetTouches[0]);
    } else {
      PCStoreJsBridge.touchStartWindow();
    }
  }, []);

  const handleTouchMove = useCallback(ev => {
    if (ev.targetTouches) {
      PCStoreJsBridge.touchMoveWindow(ev.targetTouches[0]);
    } else {
      PCStoreJsBridge.touchMoveWindow();
    }
  }, []);

  const handleTouchEnd = useCallback(ev => {
    PCStoreJsBridge.touchEndWindow();
  }, []);

  return (
    <div className={styles.category_list}>
      <div className="category_mask" onClick={closeList} />
      <div className="category_info">
        <div className="info_mask" onClick={closeList} />
        <div
          className={styles.list_info}
          ref={Node}
          onAnimationEnd={e => {
            if (e?.target?.className && e?.target?.className.indexOf(styles.list_out) > -1) {
              setTimeout(() => {
                dispatch(setGameCategoryTag(false));
              }, 50);
            }
          }}
        >
          <div className="code_info">
            <div
              onMouseDown={handleWindowHtCaption}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              <div className="back">
                <i className="iconfont icon-opt_back" onClick={closeList} />
              </div>
              <div className="list_title">筛选游戏标签</div>
            </div>

            {gameCode === '1' && (
              <>
                <div className="list_search">
                  <input placeholder="搜索游戏标签" onChange={handleSearch} />
                  <div className="search_line" />
                  <i className="iconfont icon-search" />
                  {searchShow && searchTag?.length > 0 && (
                    <div className="search_have_result">
                      {searchTag.map((tag, i) => (
                        <div
                          key={i}
                          className="search_result_item"
                          onClick={() => clickTag(tag)}
                          // dangerouslySetInnerHTML={{ __html: tagItemShow(tag) }}
                        >
                          {tag.tagName}
                        </div>
                      ))}
                    </div>
                  )}
                  {searchShow && searchTag?.length === 0 && (
                    <div className="search_no_result">找不到“{keyWords}”相关结果</div>
                  )}
                </div>
                <div className="search_tag_info">
                  {categoryTag?.length > 0 ? (
                    <>
                      {categoryTag?.map((tag, index) => {
                        return <ListItem key={index} code={gameCode} tagInfo={tag} />;
                      })}
                    </>
                  ) : (
                    <>
                      {categoryTag?.length === 0 && (
                        <div className="no_tag">
                          <img src={DefaultImg} />
                          <div>暂无标签</div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
            {gameCode === '2' && <ListItem code={gameCode} tagInfo={categoryTag} />}
          </div>
        </div>
      </div>
    </div>
  );
});
